/* Atlas footer region / currency selector (from ac-cat-v2 region.js): search filter + submit the Shopify Markets localization form. */
(function () {
  function init(root) {
    if (root.__rg) return;
    root.__rg = true;
    const input = root.querySelector('[data-region-input]');
    const search = root.querySelector('[data-region-search]');
    const items = Array.from(root.querySelectorAll('[data-country]'));
    const empty = root.querySelector('[data-region-empty]');
    const form = root.closest('form');

    items.forEach((b) => b.addEventListener('click', () => {
      if (b.classList.contains('is-on')) return;
      input.value = b.dataset.country;
      form.submit();
    }));

    if (search) {
      search.addEventListener('input', () => {
        const q = search.value.trim().toLowerCase();
        let n = 0;
        items.forEach((b) => {
          const hit = !q || b.dataset.q.indexOf(q) > -1;
          b.hidden = !hit;
          if (hit) n++;
        });
        if (empty) empty.hidden = n > 0;
      });
      search.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const first = items.find((b) => !b.hidden);
          if (first) first.click();
        }
      });
    }
  }
  const run = () => document.querySelectorAll('[data-region]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
